import { faChartLine } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModule, LineChart } from '@domain-group/suit-theme'

import useChartData from '@hooks/useChartData'

import AnalyticsBlankstateImageUrl from '../../../assets/analytics.svg'

export const icon = faChartLine

export const configOptions = () => ({
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  date_range: {
    component: 'select',
    key: 'date_range',
    label: 'Date Range',
    optionKey: 'queryParams',
    values: [
      { key: '3_months', label: '3 Months' },
      { key: '6_months', label: '6 Months' },
      { key: '12_months', label: '1 Year' },
    ],
  },
})

interface WeeklyWorkloadChartProps {
  customOptions: {
    customization?: {
      title?: string,
    },
    queryParams?: object,
  },
  editing: boolean,
}

const WeeklyWorkloadChart = (props: WeeklyWorkloadChartProps) => {
  const { customOptions, editing } = props
  const { queryParams } = customOptions || {}

  const chartDataPayload = useChartData('task_list_items_future_weekly_workload', {
    dataKeyProps: {
      average_completed_per_week: { dot: false, strokeDasharray: '4 4' },
    },
    excludedDataKeys: ['name'],
    requestOptions: queryParams,
  })
  const { dataArray, loading } = chartDataPayload

  const title = customOptions?.customization?.title

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      loading={loading}
      title={title || 'Future Weekly Workload'}
    >
      {!dataArray.length && !loading && (
        <DashboardModule.BlankState imageUrl={AnalyticsBlankstateImageUrl}>
          <DashboardModule.BlankState.Title>No Chart Available</DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>Try adjusting your filters.</DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && !!dataArray.length && (
        <Box flexDirection="column" flexWrap="wrap" padding="medium">
          <LineChart dataPayload={chartDataPayload} />
        </Box>
      )}
    </DashboardModule>
  )
}

export default WeeklyWorkloadChart
